// extracted by mini-css-extract-plugin
export var basePrice = "order-list-item-module--base-price--838dd";
export var orderCard = "order-list-item-module--order-card--176e6";
export var orderHeader = "order-list-item-module--order-header--9c39a";
export var price = "order-list-item-module--price--dc403";
export var summary = "order-list-item-module--summary--c1737";